/* 🤖 this file was generated by svg-to-ts */
export const mgcIconWineglass2Filled: {
  name: 'wineglass-2-filled';
  data: string;
} = {
  name: 'wineglass-2-filled',
  data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M3.74 3.082a1.45 1.45 0 0 0-.78.603c-.187.289-.256.567-.232.938.036.58-.23.282 4.238 4.758L11 13.421V19H9.927c-.894 0-1.105.011-1.267.066-.369.126-.66.538-.66.934 0 .242.119.521.299.701.311.312.157.299 3.701.299s3.39.013 3.701-.299a.984.984 0 0 0 0-1.402c-.278-.278-.393-.299-1.628-.299H13v-5.579l4.034-4.04c4.476-4.485 4.198-4.171 4.237-4.767.025-.37-.042-.637-.233-.932a1.44 1.44 0 0 0-.792-.602c-.251-.079-.356-.08-8.26-.078-7.82.002-8.012.004-8.246.08"/></svg>`
};
